import React, { useCallback, useState } from 'react';
import { AccordionItem, Box, Inscription, LinkButton, Text } from '@common-fe/common-fe';
import dayjs from 'dayjs';

import { ROUTES } from '@/common';
import { DEFAULT_DATE_FORMAT } from '@/common/constants';

import { Renewal } from '../../renewals.types';
import HealthPlanSummaryCard from '../components/HealthPlanSummaryCard';
import { SummaryBox } from '../styles/RenewalSetup.styles';

interface Props {
  renewalSetupData?: Renewal;
}

const HealthPlansSummary: React.FC<Props> = ({ renewalSetupData }) => {
  const [isExpanded, setExpanded] = useState(false);

  const healthPlans = renewalSetupData?.healthPlans || [];

  const handleOpenHealthPlans = useCallback(() => {
    window.open(`${ROUTES.HEALTH_PLAN_HUB}${window.location.search}`, '_blank');
  }, []);

  return (
    <SummaryBox
      onClick={() => setExpanded(!isExpanded)}
      pad={{ vertical: 'spacing12', horizontal: 'spacing16' }}
      border={{ color: 'border1', size: 'large' }}
      margin={{ bottom: 'spacing24' }}
      round="container2Round"
      background={isExpanded ? 'border1' : 'canvas'}
    >
      <AccordionItem
        testId="health-plans-summary-item"
        iconSize="24px"
        isExpanded={isExpanded}
        text={
          <Box
            background={isExpanded ? 'border1' : 'canvas'}
            margin={{ left: 'spacing2' }}
            direction="row"
            align="center"
          >
            <Inscription color="textBody" weight="normal" lineHeight="20px">
              Summary of your current health plans
            </Inscription>
          </Box>
        }
        isLeftArrow
      >
        <Box
          background="border1"
          margin={{ top: 'spacing12' }}
          onClick={(e: React.MouseEvent) => e.stopPropagation()}
        >
          <Box direction="row" justify="between" align="center" margin={{ bottom: 'spacing8' }}>
            <Text color="textBody">First and last date of plan year:</Text>
            <Text size="small" color="textBody" weight={700}>
              {dayjs(renewalSetupData?.planYear?.validFrom).format(DEFAULT_DATE_FORMAT)} –{' '}
              {renewalSetupData?.planYear?.validTo
                ? dayjs(renewalSetupData?.planYear?.validTo).format(DEFAULT_DATE_FORMAT)
                : ''}
            </Text>
          </Box>
          <Box gap="spacing12">
            {healthPlans.map((healthPlan, index) => (
              <HealthPlanSummaryCard
                key={`${healthPlan.name}-${index}`}
                healthPlan={healthPlan}
                testId={`health-plan-summary-card-${index}`}
                showEditButtons={false}
              />
            ))}
          </Box>
          <Box margin={{ top: 'spacing8' }}>
            <LinkButton onClick={handleOpenHealthPlans} style={{ margin: 'xs' }} linkInlineMode>
              Open Health Plans
            </LinkButton>
          </Box>
        </Box>
      </AccordionItem>
    </SummaryBox>
  );
};

export default HealthPlansSummary;
